import React from "react";
interface EmailIconProps {
  color?:string;
}
const EmailIcon:React.FC<EmailIconProps> = ({
  color ="#999999"
}) => {
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Vector"
          d="M16.4752 1.49365H1.47522C1.30946 1.49365 1.15049 1.5595 1.03328 1.67671C0.916068 1.79392 0.85022 1.95289 0.85022 2.11865V12.7437C0.85022 13.0752 0.981916 13.3931 1.21634 13.6275C1.45076 13.862 1.7687 13.9937 2.10022 13.9937H15.8502C16.1817 13.9937 16.4997 13.862 16.7341 13.6275C16.9685 13.3931 17.1002 13.0752 17.1002 12.7437V2.11865C17.1002 1.95289 17.0344 1.79392 16.9172 1.67671C16.8 1.5595 16.641 1.49365 16.4752 1.49365ZM14.8682 2.74365L8.97522 8.146L3.08225 2.74365H14.8682ZM15.8502 12.7437H2.10022V3.53975L8.55256 9.45459C8.66787 9.56044 8.8187 9.61917 8.97522 9.61917C9.13174 9.61917 9.28257 9.56044 9.39788 9.45459L15.8502 3.53975V12.7437Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default EmailIcon;
